import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppForm, DynamicFormContainer } from "../../../../components";
import { FormContextProvider, TabPanelContext } from "../../../../context/ContextIndex";
import { getReplacementProductSchema, getReplacementProductDefaultValue } from "../../replacement-product/create/schema";

const ReplacementProductCreate = ({ onSubmit, onCancel }) => {
  const { t } = useTranslation();
  const _tabContextObject = useContext(TabPanelContext);
  const _tabContext = _tabContextObject.getTabFormContext();

  const selectedProduct = _tabContext.data?.selectedReplacementProduct;
  const existingRanges = _tabContext?.data?.replacementProducts ? _tabContext?.data?.replacementProducts : [];

  const _formattedRange = existingRanges
    .filter((item) => !selectedProduct || item.id !== selectedProduct.id)
    .map((item) => ({
      startRange: parseFloat(item.StartFrequencyReposition),
      endRange: parseFloat(item.EndFrequencyReposition),
    }));


  const defaultFormValues = selectedProduct
    ? selectedProduct // If editing, use selected product
    : getReplacementProductDefaultValue();

  const [formdata] = useState({
    replacementProductSchema: getReplacementProductSchema(_formattedRange),
    appformdata: null,
  });


  const onReplacementProductSubmit = (data) => {
    const newProduct = {
      ...data,
      id: selectedProduct ? selectedProduct.id : _tabContext.data?.replacementProducts?.length || 0,
      ReplaceProductId: selectedProduct ? selectedProduct.ReplaceProductId : null
    };

    _tabContextObject.setTabFormContext({
      data: {
        ..._tabContext.data,
        replacementProducts: _tabContext.data?.replacementProducts
          ? (
            _tabContext.data.replacementProducts.some(product => product.id === newProduct.id)
              ? _tabContext.data.replacementProducts.map(product =>
                product.id === newProduct.id
                  ? newProduct  // If product with the same ID exists, replace it
                  : product     // Otherwise, keep the original product
              )
              : [..._tabContext.data.replacementProducts, newProduct]  // If no product with the same ID exists, add new one
          )
          : [newProduct],  // If there are no existing products, create an array with the new one
        selectedReplacementProduct: null
      },
      isDirty: true
    });


    onSubmit(); // Close form after submit
  };

  return (
    <FormContextProvider
      schema={formdata.replacementProductSchema}
      defaultValues={defaultFormValues}
      appformdata={formdata.appformdata}
    >
      <AppForm onSubmit={onReplacementProductSubmit}>
        <DynamicFormContainer
          header={selectedProduct ? t("createReplacementProducts.editHeader") : t("createReplacementProducts.header")}
          onCancel={onCancel}
          onSaveLabel={t("generic.save")}
        />
      </AppForm>
    </FormContextProvider>
  );
};

export default ReplacementProductCreate;
